// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2iecM","title":"InfoRow_title__2UHZn"};